const en = {
  app_name: 'Braids by Tifeh',
  dashboard: 'Dashboard',
  logout: 'Logout',
  login: 'Login',
};

export default en;
